
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexIO7ViiLX5L3ttvYQLK1j2_45La8KqKVRXGWlbOWXc9WiEMeta } from "/codebuild/output/src2821564992/src/pages/index.vue?macro=true";
import { default as indextDcno3IFCtXCwmEAewrkMT8o8hTdTOz8tB_zTZkm270Meta } from "/codebuild/output/src2821564992/src/pages/login/index.vue?macro=true";
import { default as indexu_CMvrFXoaupVbwZSSGJl9JtOdn9fDvKxQYcOOmnyeMMeta } from "/codebuild/output/src2821564992/src/pages/software/index.vue?macro=true";
import { default as indexOJg6RZ30eFrzD2smyOTESZm4s87sZakLBeDnuDusAygMeta } from "/codebuild/output/src2821564992/src/pages/trackers/index.vue?macro=true";
import { default as indexgjiBjVZ_45XBMjfWg0Wcx45BRI8vM3CVecaFY5_YCYHY8Meta } from "/codebuild/output/src2821564992/src/pages/templates/index.vue?macro=true";
import { default as create6F_45BwUag4ioKWATrawTPZGYRxKPaA3_451708AtTzMufAMeta } from "/codebuild/output/src2821564992/src/pages/trackers/create.vue?macro=true";
import { default as createWqZ9TNxHR5YiKHFHl6tsuCrs3pyKuOohJg4kk5SBcRUMeta } from "/codebuild/output/src2821564992/src/pages/templates/create.vue?macro=true";
import { default as indexRVUya3l8Eo_45Ti8mVVBLjYNoZXY0yOZJ1FLrq2FjAMNIMeta } from "/codebuild/output/src2821564992/src/pages/tagging-docs/index.vue?macro=true";
import { default as editoXInrNwFh4gygLyCFnU6G_45WR42tb2dU_45Q0URPIeQ7ygMeta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_93oVmsep7KY3lPnbdf4p1vMXikkac_45edAI6c1P8UF7_45t8Meta } from "/codebuild/output/src2821564992/src/pages/login/token/[token].vue?macro=true";
import { default as editGbCO7ZEUtWjJx4aOB2hZjQnrZzfz1qFH0fjzZkmczxAMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indexFYVHRiUcVK3rTQ6BakcAS1Mi5eAC0I7mLz3CUI7begcMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/index.vue?macro=true";
import { default as indexggy7Tpt8Dn0gx0Jj4bZsnEJLRlShbOtDB1WwfXNlcIoMeta } from "/codebuild/output/src2821564992/src/pages/plan-management/index.vue?macro=true";
import { default as index6Vb_dVQcCP9sm2OILL498pajcs5AZIT1e5Do214Td7wMeta } from "/codebuild/output/src2821564992/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexO4U1rv_DJda73T1CjDTcsUM8vXR_4546BMbxwoHM0OezUMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexPRM4vcmlPTFIC5udwdqeyCh4mRcuoJFwlY_p9PIalg0Meta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as indexvrWHt76UMNk5aGu2o_lXoQqsrhmJ2huwFGCu65W5WuoMeta } from "/codebuild/output/src2821564992/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as createVs0Sl_45EgsQZdA_45zhLEzsYVrOt3H71Q_458Kol_45894ZAAYMeta } from "/codebuild/output/src2821564992/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editVy3B_45WVOIaYC1cTx58AQzKt8XUYKzDgMwiLcwAjukvQMeta } from "/codebuild/output/src2821564992/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsHGeL0_457ZU_BLI0yLJFgkVE_45wRhJBP046_QCH8CASo7kMeta } from "/codebuild/output/src2821564992/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as indexzBpdp3aUAxZ8DCj_45H7_45JFHAC3X4LoJyjSmjMwfJu7DwMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createUV2pguBXQ42t9T5KaeVVEZxL4f82Ph92mwnZpAkV_45W8Meta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groupsiwv82A0IIF8bPFWr633SFZbVSHvyEy7XxMky7AZ14LsMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createu2D_45bmT3J2x9dF9afOV0_br3qJYLi57YOsKaDsIve8UMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as index5knuip0Dh5wF_45YuH0WFkQCrnb928MNtVqlucTYRXcfwMeta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexIDdSgfnTPA0L4kIo9yNFi92AqJyt7k7WORUaF_45tmr3gMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createiU0jT4_zuEgH3ZYYLjj3Ex0aFHXghLKkWFMmjU8etOIMeta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backendho5_jfl1KIPMyqsPAHX1MuyShuMBH_rD9LX3RhQ_BeIMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as created1GEgEKiMLORYwLFb8eWDyysGspIvUQrKLL0JOgY3scMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontendC6cZepFzcQM8sFe2nx5PW_45k1k8Fix9K9sNPbNOeUsoUMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePageXJCGD8ejv7xY9_45CuqJZltyjubpi_vhAQYH26w4v1XqoMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indexhEDZ1Qza4AyegXmXGcv2grmnlqOzAt7xIr_45JVKXo_4554Meta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as index4mcc9GHrAvWGcLKc7E8jprduo0TA_rKm_45Fo5nHCL0poMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershipCPHgCjeF20hIpNPmrU6KNcKANIipCxoObd_45ZzEXSXUkMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as indexTnK0useWxtur8RifD9UNoqo0FcLVI0zCEQwt7VzeFEgMeta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as index4siR2iw0CZh4OLbIk6oA_DGSU7fULT94MVHfActBzy4Meta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendFKNgY6zZUW2G2Q0ah8x7ij_45a6K2RLF_45ck_456SXgwO0OQMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v2aqFVNtI1pL_45_45v_eCuodxEvWGT4agHopDVN2CYkd8Y2gMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as edit50tDoHZMSOrCVFabAkyiFBfOimMaFo_iOd7Hs2UrGUYMeta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editMsM5Q76lNptCvP9wTqA_oPz8rdxLBDUYecZzoMgHNBkMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentsCwib8N4A524xBdvBBjgdworheVX_RmQcK34mOIcp1TIMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45sales1USGEXuxoDQgZnIvYbuU_dHC5O5et6HVf2frnL3EDnMMeta } from "/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as index4VLHUydVFhfsZFKMupO5csF0JgDXsFk48P7aOgJMrQwMeta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexSVSmlMOtg4CMw_TtOzxiWm3mpAZTmVDVu2HTp0T9CSUMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createTyldf6WWUo2WT6v7HAwuHEEXMtSBXF8IvIjBAxpedpQMeta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as createII31rFEilxAVFYOUnUw88fRBGsbXMETsWJCpHRnM2cgMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as editJTIu0M6EI84r6xOdrP8MUFP2I_UV4SaT9Ko8q2HOSY4Meta } from "/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editvLso1tTBlAznANF3dxIDo2mJVsD2PEcveHhnDScAuMQMeta } from "/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2821564992/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src2821564992/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src2821564992/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src2821564992/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src2821564992/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src2821564992/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src2821564992/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsHGeL0_457ZU_BLI0yLJFgkVE_45wRhJBP046_QCH8CASo7kMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src2821564992/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src2821564992/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src2821564992/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src2821564992/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src2821564992/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]